"use client";

import { useState } from "react";
import { Shield, TrendingUp, Clock, CheckCircle, Users, Lock } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  id: 1,
  icon: Shield,
  title: "Comprehensive Protection",
  description: "Market leading coverage for all tax enquiries including Corporation Tax, VAT, PAYE/NIC, and IR35"
}, {
  id: 2,
  icon: TrendingUp,
  title: "Expert Tax Advice",
  description: "Access to specialist tax consultants and real-time telephone support when you need it most"
}, {
  id: 3,
  icon: Clock,
  title: "Peace Of Mind",
  description: "HMRC can choose anyone for an enquiry it’s not always about wrongdoing."
}, {
  id: 4,
  icon: CheckCircle,
  title: "Increasing Enquiries",
  description: "HMRC enquiries jumped by 21% last year, generating an extra £34 billion in tax from non-compliance."
}, {
  id: 5,
  icon: Users,
  title: "Employment, HR, Health&Safety and Legal Helpline",
  description: "Telephone access to\xA0consultants who are available to assist you with\npractical advice on any employment, human resource,\xA0health & safety or general legal issues that you or your\xA0business may encounter."
}, {
  id: 6,
  icon: Lock,
  title: "Advanced Technology",
  description: "Over 80% of enquiries start with HMRC’s sophisticated database, Connect, which analyses over 55 billion lines of data, including social media, DVLA records, and bank accounts."
}];
export default function KeyBenefits() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const [hoveredId, setHoveredId] = useState<number | null>(null);
  return <section id="key-benefits" ref={sectionRef} className="relative overflow-hidden bg-background py-24 md:py-32">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          {}
          <div className="space-y-8">
            <div className={`transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <h2 className="text-[36px] md:text-[48px] leading-[1.2] font-bold tracking-[-0.2px] text-foreground mb-4">Key Benefits &amp; Reasons to take action</h2>
              <p className="text-[16px] leading-[1.6] text-muted-foreground">
                Comprehensive protection and expert support for your business
              </p>
            </div>

            <div className="space-y-4">
              {benefits.map((benefit, i) => <div key={benefit.id} data-index={i} onMouseEnter={() => setHoveredId(benefit.id)} onMouseLeave={() => setHoveredId(null)} className={`
                    flex gap-4 p-5 rounded-[var(--radius-sm)] border border-border
                    bg-surface/50 backdrop-blur-sm
                    transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]
                    ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}
                    ${hoveredId === benefit.id ? "shadow-medium -translate-y-1 bg-surface" : "shadow-soft"}
                  `} style={{
              transitionDelay: `${i * 75}ms`
            }}>
                  <div className={`
                      flex items-center justify-center size-12 rounded-[var(--radius-md)]
                      bg-primary-light shrink-0
                      transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]
                      ${hoveredId === benefit.id ? "scale-110" : "scale-100"}
                    `}>
                    <benefit.icon className={`
                        size-6 transition-colors duration-[var(--duration-medium)]
                        ${hoveredId === benefit.id ? "text-primary" : "text-primary/70"}
                      `} strokeWidth={1.5} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-[18px] font-semibold text-foreground mb-1">
                      {benefit.title}
                    </h3>
                    <p className="text-[14px] leading-[1.5] text-muted-foreground">
                      {benefit.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {}
          <div className={`
              relative transition-all duration-1000 ease-out
              ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}
            `} style={{
          transitionDelay: "200ms"
        }}>
            <div className="relative aspect-[4/5] rounded-[var(--radius-lg)] overflow-hidden shadow-strong">
              <div className="absolute inset-0 bg-cover bg-center" style={{
              backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/tax_protection_benefits_illustration.png)",
              transform: hoveredId ? "scale(1.05)" : "scale(1)",
              transition: "transform 800ms cubic-bezier(0.4, 0, 0.2, 1)"
            }} />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/20 to-transparent" />
            </div>

            {}
            <div className="absolute -top-4 -right-4 size-24 rounded-full bg-accent/10 blur-2xl" />
            <div className="absolute -bottom-6 -left-6 size-32 rounded-full bg-primary/10 blur-2xl" />
          </div>
        </div>
      </div>
    </section>;
}